import type { ShopProduct } from '@/mocks/shop';

export interface ShopProductDetail extends ShopProduct {
  images: string[];
  files: string[];
}

export interface ShopProductDbRow {
  id: string;
  title: string;
  description: string | null;
  price: number | null;
  category_id: string | null;
  city: string | null;
  images: string[] | null;
  files: string[] | null;
  contact_name: string | null;
  contact_phone: string | null;
  created_at: string | null;
}

export function mapDbProduct(row: ShopProductDbRow, categoryName: string): ShopProductDetail {
  const images = Array.isArray(row.images) ? row.images : [];
  return {
    id: row.id,
    title: row.title,
    description: row.description || '',
    price: Number(row.price) || 0,
    category: categoryName || 'Boutique',
    city: row.city || 'Lomé',
    image: images.length > 0 ? images[0] : '',
    images,
    files: Array.isArray(row.files) ? row.files : [],
    sellerName: row.contact_name || 'Vendeur',
    sellerPhone: row.contact_phone || '',
    postedAt: row.created_at ? row.created_at.slice(0, 10) : '',
  };
}